import { render, staticRenderFns } from "./case.faces.filter.vue?vue&type=template&id=36bf4e58&"
import script from "./case.faces.filter.vue?vue&type=script&lang=js&"
export * from "./case.faces.filter.vue?vue&type=script&lang=js&"
import style0 from "./case.faces.filter.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../../tmp/ffsecurity-ui/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports